<template>
  <div>
    <div style="display:flex;justify-content:center;align-items:center;font-size: 1.1rem;">
      <div style="margin-top: 50px;margin-bottom: 65px">
<!--        <table>-->

<!--          <tr><td  style="width: 400px;border:1px solid #999999;  color: #13305D;font-size: 1.3rem;"><a>Datasets classified by component type</a></td><td class="z">        <el-popover-->
<!--              placement="top-start"-->
<!--              width="250"-->
<!--              trigger="hover"-->
<!--              :content="note"-->
<!--              style="margin-left: 0px"-->
<!--          >-->
<!--            <div v-html="note"></div>-->
<!--            <el-button slot="reference" type="primary" icon="el-icon-warning-outline" circle size="small">Note</el-button>-->
<!--          </el-popover></td></tr>-->
<!--          <tr><td class="t"><a>RNA(s)</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/RNA(s).zip" download="RNA(s).zip"><i class="el-icon-download"></i></a></td></tr>-->
<!--          <tr><td class="t"><a>RNAs+protein(s)</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/RNAs+protein(s).zip" download="RNAs+protein(s).zip"><i class="el-icon-download"></i></a></td></tr>-->
<!--          <tr><td class="t"><a>RNA+protein(s)</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/RNA+protein(s).zip" download="RNA+protein(s).zip"><i class="el-icon-download" ></i></a> </td></tr>-->

<!--        </table>-->

        <table style="margin-top: 50px">
          <tr><td class="t" style="width: 400px;border:1px solid #999999;  color: #13305D;font-size: 1.3rem;">Datasets classified by RNA type</td><td class="z" style="color: #13305D;font-size: 1.2rem">Download</td></tr>
          <tr><td class="t"><a>Natural RNA</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/Natural RNA.zip" download="Natural RNA.zip"><i class="el-icon-download"></i></a></td></tr>
          <tr><td class="t"><a>Designed RNA</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/Designed RNA.zip" download="Designed RNA.zip"><i class="el-icon-download"></i></a></td></tr>
        </table>
        <table style="margin-top: 50px">
          <tr><td class="t" style="width: 400px;border:1px solid #999999;  color: #13305D;font-size: 1.3rem;">Datasets classified by in vivo/vitro</td><td class="z" style="color: #13305D;font-size: 1.2rem">Download</td></tr>
          <tr><td class="t"><a>In vivo</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/In vivo.zip" download="In vivo.zip"><i class="el-icon-download"></i></a></td></tr>
          <tr><td class="t"><a>In vitro</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/In vitro.zip" download="In vitro.zip"><i class="el-icon-download"></i></a></td></tr>
        </table>

        <table style="margin-top: 50px">
          <tr><td style="width: 400px;border:1px solid #999999;  color: #13305D;font-size: 1.3rem;"><a>All datasets</a></td><td class="z"><a href="http://www.rnaphasep.cn/static/img/All data.zip" download="All data.zip"><i class="el-icon-download"></i></a></td></tr>
        </table>

        <p style="margin-top: 30px;margin-left: 0px">You can see the Help page's "Q7" for an explanation of the data header.</p>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Download",
  data(){
    return{
      note:' · RNA: single RNA<br>' +
          ' · RNAs: multiple RNAs<br>' +
          ' · RNA(s): one or more RNAs<br>'+
          ' · protein(s): one or more proteins'
    }
  }
}
</script>

<style scoped>
p{
  margin-top:5px;
  margin-bottom: 0px;
  margin-left:40px;
}
a{
  text-decoration: none;
}
img{
  margin-left: 10px;
}
.el-divider{
  margin-top: 0px;
  margin-left: 40px;
  width: 430px;
  margin-bottom: 0px;
}
.t{
  width: 300px;
  font-size: 1.1rem;
  border:1px solid #999999
}
.z{
  width: 100px;
  border:1px solid #999999
}
header{
  text-align: center;
  color: #13305D;
  font-size: 1.3rem;
  width: 400px;
  border:1px solid #999999
}
table{
  border: #13305D 1px solid;
  text-align: center;
  cellspacing: 0;
}
i{
  color: #0e63bb;
}
</style>